import { api } from './client';
import { ADMIN_PAGE_SIZE } from './adminTypes';
export async function fetchPromotionRuleDefinitions() {
    const res = await api.get('/v1/admin/promotions/rule-definitions');
    return res.data;
}
export async function fetchAdminPromotionsPage(page = 0, size = ADMIN_PAGE_SIZE, params = {}) {
    const res = await api.get('/v1/admin/promotions', {
        params: { page, size, ...params },
    });
    return res.data;
}
export async function fetchAdminPromotion(id) {
    const res = await api.get(`/v1/admin/promotions/${id}`);
    return res.data;
}
export async function createAdminPromotion(body) {
    const res = await api.post('/v1/admin/promotions', body);
    return res.data;
}
export async function updateAdminPromotion(id, body) {
    const res = await api.put(`/v1/admin/promotions/${id}`, body);
    return res.data;
}
export async function setAdminPromotionActive(id, isActive) {
    const res = await api.patch(`/v1/admin/promotions/${id}/active`, { isActive });
    return res.data;
}
export async function deleteAdminPromotion(id) {
    await api.delete(`/v1/admin/promotions/${id}`);
}
export async function broadcastAdminPromotion(promotionId, subject, message) {
    const res = await api.post('/v1/admin/promotions/broadcast', {
        promotionId,
        subject,
        message,
    });
    return res.data;
}
